import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMachines } from '../context/MachineContext';
import { COMPANY } from '../constants';
import styles from './AdminLoginPage.module.css';

export default function AdminLoginPage() {
  const { login, isAdmin, adminPasswordLoaded } = useMachines();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Already logged in
  if (isAdmin) {
    navigate('/admin');
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!adminPasswordLoaded) return;
    setLoading(true);
    setError('');
    setTimeout(() => {
      const ok = login(password);
      if (ok) {
        navigate('/admin');
      } else {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
      setLoading(false);
    }, 400);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <span className={styles.logoIcon}>⚙️</span>
          <span className={styles.logoText}>{COMPANY.name}</span>
        </div>
        <h1 className={styles.title}>Admin Access</h1>
        <p className={styles.sub}>Enter your admin password to manage machinery listings.</p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.fieldWrap}>
            <label className={styles.label}>Admin Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              className={`${styles.input} ${error ? styles.inputErr : ''}`}
              autoFocus
              maxLength={12}
              autoComplete="current-password"
            />
            {error && <p className={styles.error}>{error}</p>}
          </div>

          <button
            type="submit"
            className={styles.btn}
            disabled={loading || !password || !adminPasswordLoaded}
          >
            {loading ? 'Verifying…' : !adminPasswordLoaded ? 'Loading…' : 'Sign In →'}
          </button>
        </form>

        <p className={styles.hint}>
          This panel is for authorised administrators only.
        </p>
      </div>
    </div>
  );
}
